import LinkWrapper from "../LinkWrapper";
import ThumbnailListItem from "../Thumbnails/ThumbnailListItem";
import { ICourseVideoBanner } from "./interfaces";

const CourseVideoBanner = (props: { item: ICourseVideoBanner }) => {
  const item = props.item;
  if(!item.imgUrl) return null;

  return <div className="text-center">
    <ThumbnailListItem item={item}/>
    <LinkWrapper className="inline-block link !text-[#FFE0B2] py-4 font-medium" href={item.viewMore?.href }>
      {item.viewMore?.text}
    </LinkWrapper>
  </div>
}


export default CourseVideoBanner;